/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Kitdex API — football shirt catalog and listings.
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthSuccess,
  BlogArticle,
  BlogArticlePage,
  BlogPublishInput,
  BlogPublishResult,
  CatalogFacets,
  CatalogStats,
  ChangeEmailRequest,
  ChangePasswordRequest,
  ClerkExchangeRequest,
  ConfirmEmailVerificationParams,
  CsrfToken,
  CurrentUserResponse,
  EmailVerificationResult,
  ErrorResponse,
  GetShirtBySlugParams,
  GetWatchlistParams,
  HealthStatus,
  ListBlogArticlesParams,
  OkResponse,
  PasswordResetComplete,
  PasswordResetRequest,
  PhotoScanRequest,
  PhotoScanResponse,
  SearchShirtsParams,
  ShirtDetail,
  ShirtSearchResults,
  SignInRequest,
  SignUpRequest,
  WashtagLookupRequest,
  WashtagLookupResponse,
  WatchlistIdsResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List published editorial articles
 */
export const getListBlogArticlesUrl = (params?: ListBlogArticlesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/blog/articles?${stringifiedParams}`
    : `/api/blog/articles`;
};

export const listBlogArticles = async (
  params?: ListBlogArticlesParams,
  options?: RequestInit,
): Promise<BlogArticlePage> => {
  return customFetch<BlogArticlePage>(getListBlogArticlesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListBlogArticlesQueryKey = (
  params?: ListBlogArticlesParams,
) => {
  return [`/api/blog/articles`, ...(params ? [params] : [])] as const;
};

export const getListBlogArticlesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBlogArticles>>,
  TError = ErrorType<void>,
>(
  params?: ListBlogArticlesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBlogArticles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBlogArticlesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBlogArticles>>
  > = ({ signal }) => listBlogArticles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBlogArticles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBlogArticlesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBlogArticles>>
>;
export type ListBlogArticlesQueryError = ErrorType<void>;

/**
 * @summary List published editorial articles
 */

export function useListBlogArticles<
  TData = Awaited<ReturnType<typeof listBlogArticles>>,
  TError = ErrorType<void>,
>(
  params?: ListBlogArticlesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBlogArticles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBlogArticlesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Read a published article
 */
export const getGetBlogArticleUrl = (slug: string) => {
  return `/api/blog/articles/${slug}`;
};

export const getBlogArticle = async (
  slug: string,
  options?: RequestInit,
): Promise<BlogArticle> => {
  return customFetch<BlogArticle>(getGetBlogArticleUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetBlogArticleQueryKey = (slug: string) => {
  return [`/api/blog/articles/${slug}`] as const;
};

export const getGetBlogArticleQueryOptions = <
  TData = Awaited<ReturnType<typeof getBlogArticle>>,
  TError = ErrorType<void>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBlogArticle>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBlogArticleQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlogArticle>>> = ({
    signal,
  }) => getBlogArticle(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBlogArticle>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBlogArticleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBlogArticle>>
>;
export type GetBlogArticleQueryError = ErrorType<void>;

/**
 * @summary Read a published article
 */

export function useGetBlogArticle<
  TData = Awaited<ReturnType<typeof getBlogArticle>>,
  TError = ErrorType<void>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBlogArticle>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBlogArticleQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or correct an approved article
 */
export const getPublishBlogArticleUrl = (slug: string) => {
  return `/api/blog/articles/${slug}`;
};

export const publishBlogArticle = async (
  slug: string,
  blogPublishInput: BlogPublishInput,
  options?: RequestInit,
): Promise<BlogPublishResult> => {
  return customFetch<BlogPublishResult>(getPublishBlogArticleUrl(slug), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(blogPublishInput),
  });
};

export const getPublishBlogArticleMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishBlogArticle>>,
    TError,
    { slug: string; data: BodyType<BlogPublishInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishBlogArticle>>,
  TError,
  { slug: string; data: BodyType<BlogPublishInput> },
  TContext
> => {
  const mutationKey = ["publishBlogArticle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishBlogArticle>>,
    { slug: string; data: BodyType<BlogPublishInput> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return publishBlogArticle(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishBlogArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishBlogArticle>>
>;
export type PublishBlogArticleMutationBody = BodyType<BlogPublishInput>;
export type PublishBlogArticleMutationError = ErrorType<void>;

/**
 * @summary Create or correct an approved article
 */
export const usePublishBlogArticle = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishBlogArticle>>,
    TError,
    { slug: string; data: BodyType<BlogPublishInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof publishBlogArticle>>,
  TError,
  { slug: string; data: BodyType<BlogPublishInput> },
  TContext
> => {
  return useMutation(getPublishBlogArticleMutationOptions(options));
};

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a CSRF token. The same token is also set as a non-HTTP-only cookie. State-changing auth endpoints require the token to be echoed in the `x-csrf-token` header.
 * @summary Issue a CSRF token bound to the current cookie
 */
export const getGetCsrfTokenUrl = () => {
  return `/api/auth/csrf`;
};

export const getCsrfToken = async (
  options?: RequestInit,
): Promise<CsrfToken> => {
  return customFetch<CsrfToken>(getGetCsrfTokenUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCsrfTokenQueryKey = () => {
  return [`/api/auth/csrf`] as const;
};

export const getGetCsrfTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getCsrfToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCsrfToken>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCsrfTokenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCsrfToken>>> = ({
    signal,
  }) => getCsrfToken({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCsrfToken>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCsrfTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCsrfToken>>
>;
export type GetCsrfTokenQueryError = ErrorType<unknown>;

/**
 * @summary Issue a CSRF token bound to the current cookie
 */

export function useGetCsrfToken<
  TData = Awaited<ReturnType<typeof getCsrfToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCsrfToken>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCsrfTokenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Return the currently signed-in user, or null
 */
export const getGetCurrentUserUrl = () => {
  return `/api/auth/me`;
};

export const getCurrentUser = async (
  options?: RequestInit,
): Promise<CurrentUserResponse> => {
  return customFetch<CurrentUserResponse>(getGetCurrentUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentUserQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({
    signal,
  }) => getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUser>>
>;
export type GetCurrentUserQueryError = ErrorType<unknown>;

/**
 * @summary Return the currently signed-in user, or null
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an account with email + password
 */
export const getSignUpWithPasswordUrl = () => {
  return `/api/auth/sign-up`;
};

export const signUpWithPassword = async (
  signUpRequest: SignUpRequest,
  options?: RequestInit,
): Promise<AuthSuccess> => {
  return customFetch<AuthSuccess>(getSignUpWithPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(signUpRequest),
  });
};

export const getSignUpWithPasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUpWithPassword>>,
    TError,
    { data: BodyType<SignUpRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signUpWithPassword>>,
  TError,
  { data: BodyType<SignUpRequest> },
  TContext
> => {
  const mutationKey = ["signUpWithPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signUpWithPassword>>,
    { data: BodyType<SignUpRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return signUpWithPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignUpWithPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof signUpWithPassword>>
>;
export type SignUpWithPasswordMutationBody = BodyType<SignUpRequest>;
export type SignUpWithPasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create an account with email + password
 */
export const useSignUpWithPassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUpWithPassword>>,
    TError,
    { data: BodyType<SignUpRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signUpWithPassword>>,
  TError,
  { data: BodyType<SignUpRequest> },
  TContext
> => {
  return useMutation(getSignUpWithPasswordMutationOptions(options));
};

/**
 * @summary Sign in with email + password
 */
export const getSignInWithPasswordUrl = () => {
  return `/api/auth/sign-in`;
};

export const signInWithPassword = async (
  signInRequest: SignInRequest,
  options?: RequestInit,
): Promise<AuthSuccess> => {
  return customFetch<AuthSuccess>(getSignInWithPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(signInRequest),
  });
};

export const getSignInWithPasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInWithPassword>>,
    TError,
    { data: BodyType<SignInRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signInWithPassword>>,
  TError,
  { data: BodyType<SignInRequest> },
  TContext
> => {
  const mutationKey = ["signInWithPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signInWithPassword>>,
    { data: BodyType<SignInRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return signInWithPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInWithPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof signInWithPassword>>
>;
export type SignInWithPasswordMutationBody = BodyType<SignInRequest>;
export type SignInWithPasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Sign in with email + password
 */
export const useSignInWithPassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInWithPassword>>,
    TError,
    { data: BodyType<SignInRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signInWithPassword>>,
  TError,
  { data: BodyType<SignInRequest> },
  TContext
> => {
  return useMutation(getSignInWithPasswordMutationOptions(options));
};

/**
 * @summary End the current session
 */
export const getSignOutUrl = () => {
  return `/api/auth/sign-out`;
};

export const signOut = async (options?: RequestInit): Promise<OkResponse> => {
  return customFetch<OkResponse>(getSignOutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSignOutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signOut>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signOut>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["signOut"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signOut>>,
    void
  > = () => {
    return signOut(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignOutMutationResult = NonNullable<
  Awaited<ReturnType<typeof signOut>>
>;

export type SignOutMutationError = ErrorType<unknown>;

/**
 * @summary End the current session
 */
export const useSignOut = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signOut>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signOut>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSignOutMutationOptions(options));
};

/**
 * @summary Send a password-reset email (or log link in dev)
 */
export const getRequestPasswordResetUrl = () => {
  return `/api/auth/password-reset/request`;
};

export const requestPasswordReset = async (
  passwordResetRequest: PasswordResetRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRequestPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(passwordResetRequest),
  });
};

export const getRequestPasswordResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetRequest> },
  TContext
> => {
  const mutationKey = ["requestPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    { data: BodyType<PasswordResetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody = BodyType<PasswordResetRequest>;
export type RequestPasswordResetMutationError = ErrorType<unknown>;

/**
 * @summary Send a password-reset email (or log link in dev)
 */
export const useRequestPasswordReset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetRequest> },
  TContext
> => {
  return useMutation(getRequestPasswordResetMutationOptions(options));
};

/**
 * Verifies the Clerk session token server-side, maps the Clerk user to a local Kitdex account (creating one on first sign-in), issues a `kd_session` cookie, and returns the local user object. Requires a valid CSRF token.
 * @summary Exchange a Clerk session token for a Kitdex session
 */
export const getExchangeClerkSessionUrl = () => {
  return `/api/auth/clerk/exchange`;
};

export const exchangeClerkSession = async (
  clerkExchangeRequest: ClerkExchangeRequest,
  options?: RequestInit,
): Promise<AuthSuccess> => {
  return customFetch<AuthSuccess>(getExchangeClerkSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(clerkExchangeRequest),
  });
};

export const getExchangeClerkSessionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exchangeClerkSession>>,
    TError,
    { data: BodyType<ClerkExchangeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exchangeClerkSession>>,
  TError,
  { data: BodyType<ClerkExchangeRequest> },
  TContext
> => {
  const mutationKey = ["exchangeClerkSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exchangeClerkSession>>,
    { data: BodyType<ClerkExchangeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return exchangeClerkSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExchangeClerkSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof exchangeClerkSession>>
>;
export type ExchangeClerkSessionMutationBody = BodyType<ClerkExchangeRequest>;
export type ExchangeClerkSessionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Exchange a Clerk session token for a Kitdex session
 */
export const useExchangeClerkSession = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exchangeClerkSession>>,
    TError,
    { data: BodyType<ClerkExchangeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exchangeClerkSession>>,
  TError,
  { data: BodyType<ClerkExchangeRequest> },
  TContext
> => {
  return useMutation(getExchangeClerkSessionMutationOptions(options));
};

/**
 * @summary Consume a reset token and set a new password
 */
export const getCompletePasswordResetUrl = () => {
  return `/api/auth/password-reset/complete`;
};

export const completePasswordReset = async (
  passwordResetComplete: PasswordResetComplete,
  options?: RequestInit,
): Promise<AuthSuccess> => {
  return customFetch<AuthSuccess>(getCompletePasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(passwordResetComplete),
  });
};

export const getCompletePasswordResetMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completePasswordReset>>,
    TError,
    { data: BodyType<PasswordResetComplete> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completePasswordReset>>,
  TError,
  { data: BodyType<PasswordResetComplete> },
  TContext
> => {
  const mutationKey = ["completePasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completePasswordReset>>,
    { data: BodyType<PasswordResetComplete> }
  > = (props) => {
    const { data } = props ?? {};

    return completePasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompletePasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof completePasswordReset>>
>;
export type CompletePasswordResetMutationBody = BodyType<PasswordResetComplete>;
export type CompletePasswordResetMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Consume a reset token and set a new password
 */
export const useCompletePasswordReset = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completePasswordReset>>,
    TError,
    { data: BodyType<PasswordResetComplete> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completePasswordReset>>,
  TError,
  { data: BodyType<PasswordResetComplete> },
  TContext
> => {
  return useMutation(getCompletePasswordResetMutationOptions(options));
};

/**
 * Full-text + faceted search across the shirt catalog.
 * @summary Search the shirt catalog
 */
export const getSearchShirtsUrl = (params?: SearchShirtsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/shirts?${stringifiedParams}`
    : `/api/shirts`;
};

export const searchShirts = async (
  params?: SearchShirtsParams,
  options?: RequestInit,
): Promise<ShirtSearchResults> => {
  return customFetch<ShirtSearchResults>(getSearchShirtsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchShirtsQueryKey = (params?: SearchShirtsParams) => {
  return [`/api/shirts`, ...(params ? [params] : [])] as const;
};

export const getSearchShirtsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchShirts>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchShirtsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchShirts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchShirtsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchShirts>>> = ({
    signal,
  }) => searchShirts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchShirts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchShirtsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchShirts>>
>;
export type SearchShirtsQueryError = ErrorType<unknown>;

/**
 * @summary Search the shirt catalog
 */

export function useSearchShirts<
  TData = Awaited<ReturnType<typeof searchShirts>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchShirtsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchShirts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchShirtsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the shirt, its variants, and current listings.
 * @summary Get a canonical shirt record by slug
 */
export const getGetShirtBySlugUrl = (
  slug: string,
  params?: GetShirtBySlugParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/shirts/${slug}?${stringifiedParams}`
    : `/api/shirts/${slug}`;
};

export const getShirtBySlug = async (
  slug: string,
  params?: GetShirtBySlugParams,
  options?: RequestInit,
): Promise<ShirtDetail> => {
  return customFetch<ShirtDetail>(getGetShirtBySlugUrl(slug, params), {
    ...options,
    method: "GET",
  });
};

export const getGetShirtBySlugQueryKey = (
  slug: string,
  params?: GetShirtBySlugParams,
) => {
  return [`/api/shirts/${slug}`, ...(params ? [params] : [])] as const;
};

export const getGetShirtBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getShirtBySlug>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: GetShirtBySlugParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShirtBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetShirtBySlugQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShirtBySlug>>> = ({
    signal,
  }) => getShirtBySlug(slug, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getShirtBySlug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetShirtBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShirtBySlug>>
>;
export type GetShirtBySlugQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a canonical shirt record by slug
 */

export function useGetShirtBySlug<
  TData = Awaited<ReturnType<typeof getShirtBySlug>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: GetShirtBySlugParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getShirtBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetShirtBySlugQueryOptions(slug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lightweight aggregated facets to power browse UI without a full search.
 * @summary Browse facets — clubs, seasons, manufacturers, eras
 */
export const getGetCatalogFacetsUrl = () => {
  return `/api/facets`;
};

export const getCatalogFacets = async (
  options?: RequestInit,
): Promise<CatalogFacets> => {
  return customFetch<CatalogFacets>(getGetCatalogFacetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCatalogFacetsQueryKey = () => {
  return [`/api/facets`] as const;
};

export const getGetCatalogFacetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogFacets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogFacets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCatalogFacetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogFacets>>
  > = ({ signal }) => getCatalogFacets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogFacets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCatalogFacetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogFacets>>
>;
export type GetCatalogFacetsQueryError = ErrorType<unknown>;

/**
 * @summary Browse facets — clubs, seasons, manufacturers, eras
 */

export function useGetCatalogFacets<
  TData = Awaited<ReturnType<typeof getCatalogFacets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogFacets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCatalogFacetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Signed-in users only. Detects the manufacturer from the code's format,
runs an exact match against known variant codes, and falls back to a
fuzzy match when no exact hit is found. Rate-limited per user and per IP.

 * @summary Look up a shirt by wash-tag manufacturer code
 */
export const getLookupWashtagUrl = () => {
  return `/api/lookup/washtag`;
};

export const lookupWashtag = async (
  washtagLookupRequest: WashtagLookupRequest,
  options?: RequestInit,
): Promise<WashtagLookupResponse> => {
  return customFetch<WashtagLookupResponse>(getLookupWashtagUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(washtagLookupRequest),
  });
};

export const getLookupWashtagMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupWashtag>>,
    TError,
    { data: BodyType<WashtagLookupRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupWashtag>>,
  TError,
  { data: BodyType<WashtagLookupRequest> },
  TContext
> => {
  const mutationKey = ["lookupWashtag"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupWashtag>>,
    { data: BodyType<WashtagLookupRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return lookupWashtag(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupWashtagMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupWashtag>>
>;
export type LookupWashtagMutationBody = BodyType<WashtagLookupRequest>;
export type LookupWashtagMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Look up a shirt by wash-tag manufacturer code
 */
export const useLookupWashtag = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupWashtag>>,
    TError,
    { data: BodyType<WashtagLookupRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lookupWashtag>>,
  TError,
  { data: BodyType<WashtagLookupRequest> },
  TContext
> => {
  return useMutation(getLookupWashtagMutationOptions(options));
};

/**
 * Signed-in users only. Sends a base64-encoded camera capture to a frontier
vision model and returns ranked candidate shirts matched against the catalog.
Captcha-protected and gated by a daily global vision spend cap and per-user
rate limit. When the daily cap is hit, returns 429 with `error: budget_exhausted`.

 * @summary Identify a shirt from a captured photo (vision LLM)
 */
export const getIdentifyShirtPhotoUrl = () => {
  return `/api/scan/photo`;
};

export const identifyShirtPhoto = async (
  photoScanRequest: PhotoScanRequest,
  options?: RequestInit,
): Promise<PhotoScanResponse> => {
  return customFetch<PhotoScanResponse>(getIdentifyShirtPhotoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(photoScanRequest),
  });
};

export const getIdentifyShirtPhotoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof identifyShirtPhoto>>,
    TError,
    { data: BodyType<PhotoScanRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof identifyShirtPhoto>>,
  TError,
  { data: BodyType<PhotoScanRequest> },
  TContext
> => {
  const mutationKey = ["identifyShirtPhoto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof identifyShirtPhoto>>,
    { data: BodyType<PhotoScanRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return identifyShirtPhoto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IdentifyShirtPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof identifyShirtPhoto>>
>;
export type IdentifyShirtPhotoMutationBody = BodyType<PhotoScanRequest>;
export type IdentifyShirtPhotoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Identify a shirt from a captured photo (vision LLM)
 */
export const useIdentifyShirtPhoto = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof identifyShirtPhoto>>,
    TError,
    { data: BodyType<PhotoScanRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof identifyShirtPhoto>>,
  TError,
  { data: BodyType<PhotoScanRequest> },
  TContext
> => {
  return useMutation(getIdentifyShirtPhotoMutationOptions(options));
};

/**
 * @summary Catalog headline stats for the home page
 */
export const getGetCatalogStatsUrl = () => {
  return `/api/stats`;
};

export const getCatalogStats = async (
  options?: RequestInit,
): Promise<CatalogStats> => {
  return customFetch<CatalogStats>(getGetCatalogStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCatalogStatsQueryKey = () => {
  return [`/api/stats`] as const;
};

export const getGetCatalogStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCatalogStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogStats>>> = ({
    signal,
  }) => getCatalogStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCatalogStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogStats>>
>;
export type GetCatalogStatsQueryError = ErrorType<unknown>;

/**
 * @summary Catalog headline stats for the home page
 */

export function useGetCatalogStats<
  TData = Awaited<ReturnType<typeof getCatalogStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCatalogStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send a verification email to the current user's address
 */
export const getRequestEmailVerificationUrl = () => {
  return `/api/auth/verify-email/request`;
};

export const requestEmailVerification = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRequestEmailVerificationUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRequestEmailVerificationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestEmailVerification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestEmailVerification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["requestEmailVerification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestEmailVerification>>,
    void
  > = () => {
    return requestEmailVerification(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestEmailVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestEmailVerification>>
>;

export type RequestEmailVerificationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send a verification email to the current user's address
 */
export const useRequestEmailVerification = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestEmailVerification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestEmailVerification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRequestEmailVerificationMutationOptions(options));
};

/**
 * @summary Consume a verification token and mark email as verified
 */
export const getConfirmEmailVerificationUrl = (
  params: ConfirmEmailVerificationParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/auth/verify-email/confirm?${stringifiedParams}`
    : `/api/auth/verify-email/confirm`;
};

export const confirmEmailVerification = async (
  params: ConfirmEmailVerificationParams,
  options?: RequestInit,
): Promise<EmailVerificationResult> => {
  return customFetch<EmailVerificationResult>(
    getConfirmEmailVerificationUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getConfirmEmailVerificationQueryKey = (
  params?: ConfirmEmailVerificationParams,
) => {
  return [
    `/api/auth/verify-email/confirm`,
    ...(params ? [params] : []),
  ] as const;
};

export const getConfirmEmailVerificationQueryOptions = <
  TData = Awaited<ReturnType<typeof confirmEmailVerification>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ConfirmEmailVerificationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof confirmEmailVerification>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getConfirmEmailVerificationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof confirmEmailVerification>>
  > = ({ signal }) =>
    confirmEmailVerification(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof confirmEmailVerification>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConfirmEmailVerificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof confirmEmailVerification>>
>;
export type ConfirmEmailVerificationQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Consume a verification token and mark email as verified
 */

export function useConfirmEmailVerification<
  TData = Awaited<ReturnType<typeof confirmEmailVerification>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: ConfirmEmailVerificationParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof confirmEmailVerification>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConfirmEmailVerificationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Resend the verification email (rate limited)
 */
export const getResendEmailVerificationUrl = () => {
  return `/api/auth/verify-email/resend`;
};

export const resendEmailVerification = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getResendEmailVerificationUrl(), {
    ...options,
    method: "POST",
  });
};

export const getResendEmailVerificationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendEmailVerification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendEmailVerification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resendEmailVerification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendEmailVerification>>,
    void
  > = () => {
    return resendEmailVerification(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendEmailVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendEmailVerification>>
>;

export type ResendEmailVerificationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Resend the verification email (rate limited)
 */
export const useResendEmailVerification = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendEmailVerification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendEmailVerification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getResendEmailVerificationMutationOptions(options));
};

/**
 * @summary Change the current user's password
 */
export const getChangePasswordUrl = () => {
  return `/api/account/change-password`;
};

export const changePassword = async (
  changePasswordRequest: ChangePasswordRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getChangePasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changePasswordRequest),
  });
};

export const getChangePasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  const mutationKey = ["changePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: BodyType<ChangePasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return changePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = BodyType<ChangePasswordRequest>;
export type ChangePasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Change the current user's password
 */
export const useChangePassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  return useMutation(getChangePasswordMutationOptions(options));
};

/**
 * @summary Request an email address change (sends confirmation to new address)
 */
export const getChangeEmailUrl = () => {
  return `/api/account/change-email`;
};

export const changeEmail = async (
  changeEmailRequest: ChangeEmailRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getChangeEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changeEmailRequest),
  });
};

export const getChangeEmailMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeEmail>>,
    TError,
    { data: BodyType<ChangeEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeEmail>>,
  TError,
  { data: BodyType<ChangeEmailRequest> },
  TContext
> => {
  const mutationKey = ["changeEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeEmail>>,
    { data: BodyType<ChangeEmailRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return changeEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeEmail>>
>;
export type ChangeEmailMutationBody = BodyType<ChangeEmailRequest>;
export type ChangeEmailMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request an email address change (sends confirmation to new address)
 */
export const useChangeEmail = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeEmail>>,
    TError,
    { data: BodyType<ChangeEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeEmail>>,
  TError,
  { data: BodyType<ChangeEmailRequest> },
  TContext
> => {
  return useMutation(getChangeEmailMutationOptions(options));
};

/**
 * @summary Get the current user's watchlist (paginated, filterable)
 */
export const getGetWatchlistUrl = (params?: GetWatchlistParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/watchlist?${stringifiedParams}`
    : `/api/watchlist`;
};

export const getWatchlist = async (
  params?: GetWatchlistParams,
  options?: RequestInit,
): Promise<ShirtSearchResults> => {
  return customFetch<ShirtSearchResults>(getGetWatchlistUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetWatchlistQueryKey = (params?: GetWatchlistParams) => {
  return [`/api/watchlist`, ...(params ? [params] : [])] as const;
};

export const getGetWatchlistQueryOptions = <
  TData = Awaited<ReturnType<typeof getWatchlist>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetWatchlistParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWatchlist>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWatchlistQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWatchlist>>> = ({
    signal,
  }) => getWatchlist(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWatchlist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWatchlistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWatchlist>>
>;
export type GetWatchlistQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the current user's watchlist (paginated, filterable)
 */

export function useGetWatchlist<
  TData = Awaited<ReturnType<typeof getWatchlist>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetWatchlistParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWatchlist>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWatchlistQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get all shirt IDs in the current user's watchlist (for button state)
 */
export const getGetWatchlistIdsUrl = () => {
  return `/api/watchlist/ids`;
};

export const getWatchlistIds = async (
  options?: RequestInit,
): Promise<WatchlistIdsResponse> => {
  return customFetch<WatchlistIdsResponse>(getGetWatchlistIdsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWatchlistIdsQueryKey = () => {
  return [`/api/watchlist/ids`] as const;
};

export const getGetWatchlistIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWatchlistIds>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWatchlistIds>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWatchlistIdsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWatchlistIds>>> = ({
    signal,
  }) => getWatchlistIds({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWatchlistIds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWatchlistIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWatchlistIds>>
>;
export type GetWatchlistIdsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get all shirt IDs in the current user's watchlist (for button state)
 */

export function useGetWatchlistIds<
  TData = Awaited<ReturnType<typeof getWatchlistIds>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWatchlistIds>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWatchlistIdsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a shirt to the current user's watchlist
 */
export const getAddToWatchlistUrl = (shirtId: number) => {
  return `/api/watchlist/${shirtId}`;
};

export const addToWatchlist = async (
  shirtId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAddToWatchlistUrl(shirtId), {
    ...options,
    method: "POST",
  });
};

export const getAddToWatchlistMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addToWatchlist>>,
    TError,
    { shirtId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addToWatchlist>>,
  TError,
  { shirtId: number },
  TContext
> => {
  const mutationKey = ["addToWatchlist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addToWatchlist>>,
    { shirtId: number }
  > = (props) => {
    const { shirtId } = props ?? {};

    return addToWatchlist(shirtId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddToWatchlistMutationResult = NonNullable<
  Awaited<ReturnType<typeof addToWatchlist>>
>;

export type AddToWatchlistMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Add a shirt to the current user's watchlist
 */
export const useAddToWatchlist = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addToWatchlist>>,
    TError,
    { shirtId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addToWatchlist>>,
  TError,
  { shirtId: number },
  TContext
> => {
  return useMutation(getAddToWatchlistMutationOptions(options));
};

/**
 * @summary Remove a shirt from the current user's watchlist
 */
export const getRemoveFromWatchlistUrl = (shirtId: number) => {
  return `/api/watchlist/${shirtId}`;
};

export const removeFromWatchlist = async (
  shirtId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRemoveFromWatchlistUrl(shirtId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveFromWatchlistMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFromWatchlist>>,
    TError,
    { shirtId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFromWatchlist>>,
  TError,
  { shirtId: number },
  TContext
> => {
  const mutationKey = ["removeFromWatchlist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFromWatchlist>>,
    { shirtId: number }
  > = (props) => {
    const { shirtId } = props ?? {};

    return removeFromWatchlist(shirtId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFromWatchlistMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFromWatchlist>>
>;

export type RemoveFromWatchlistMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Remove a shirt from the current user's watchlist
 */
export const useRemoveFromWatchlist = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFromWatchlist>>,
    TError,
    { shirtId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeFromWatchlist>>,
  TError,
  { shirtId: number },
  TContext
> => {
  return useMutation(getRemoveFromWatchlistMutationOptions(options));
};
